import { useEffect, useState } from "react";
import './Hello.css'
import Header from "../Header";
import Footer from "../Footer";
import PageTransition from "../../PageTransition";
export default function ContentHello() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      i++;
      setStep(i);
      if (i === 7) clearInterval(interval);
    }, 700);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
         <Header visible mode="normal" />
                 <PageTransition>
         
    <div className="section-content container d-flex justify-content-center">
      <h1 className="animated-text">
        We are the strategic partners fuelled by next-generation thinking. We
        pursue clarity, push boundaries, and execute with unparalleled velocity.
        Backed by a high-performance team, we deploy comprehensive{" "}

        <span className={word(step, 1)}>Branding</span>,
{" "}

        <span className={word(step, 2)}>Web Design</span>,
{" "}

        <span className={word(step, 3)}>Production</span>,
{" "}

        <span className={word(step, 4)}>Post-Production</span>, and
{" "}

        <span className={word(step, 5)}>SEO/GEO Optimization.</span> 
        
        <div className="mt-5">All designed to set your brand{" "}

        <span className={twoLY(step)}>Two Light Years</span>{" "}

        <span className={curve(step)}>ahead of the curve</span>.
      </div>
      </h1>
    </div>
    </PageTransition>
    <Footer visible mode="normal" />

    </>
  );
}

/* ---------- helpers ---------- */

function word(step, index) {
  if (step === index) return "text-active";
  if (step > index) return "text-dull";
  return "text-dull";
}

function twoLY(step) {
  if (step >= 6) return "text-final"; 
  return "text-dull";
}

function curve(step) {
  if (step >= 6) return "text-white";
  return "text-dull";
}
